import { graphql } from "../gql";

export const drgDeleteAnnotationMutationDoc = graphql(`
  mutation drgDeleteAnnotation($id: ID!) {
    drgDeleteAnnotation(id: $id)
  }
`);
